import { render, staticRenderFns } from "./TextWithImageSlider.vue?vue&type=template&id=b9337bc8"
import script from "./TextWithImageSlider.vue?vue&type=script&lang=js"
export * from "./TextWithImageSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports